/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Availabletoreadforuserids6Inputs */

const de__field_availabletoreadforuserids6 = /** @type {(inputs: _Field_Availabletoreadforuserids6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verfügbar zum Lesen für Benutzer-IDs`)
};

/**

* @param {_Field_Availabletoreadforuserids6Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_availabletoreadforuserids6 = /** @type {((inputs?: _Field_Availabletoreadforuserids6Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Availabletoreadforuserids6Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_availabletoreadforuserids6(inputs)
});
export { _field_availabletoreadforuserids6 as "_field_availableToReadForUserIDs" }